import { connect } from 'react-redux';
import sendOrderConfEmail from '../../actions/userInformation/orderConfEmail';
import OrderConfirmPageLayout from './OrderConfirmPageLayout';

const mapStateToProps = ({ orders: { currentOrder } }) => ({
  orderNumber: currentOrder || '',
});

const mapDispatchToProps = {
  sendConfConnect: sendOrderConfEmail,
};
export default connect(mapStateToProps, mapDispatchToProps)(
  OrderConfirmPageLayout
);



// WEBPACK FOOTER //
// ./src/containers/OrderConfirmPage/OrderConfirmPage.js